import { getCards, getExercises } from "./reducer";
import { store } from "../store";

import _ from "lodash";

import constants from "./constants";

// const uuid4 = require("uuid/v4");
import { uuid4 } from "uuid/v4";

export const fetchStreams = () => ({
  type: constants.FETCH_STREAMS,
});

export const activateProgram = (program, day_uuid = "") => ({
  type: constants.ACTIVATE_PROGRAM,
  payload: { ...program, day_uuid: day_uuid },
});

export const activateDay = (id) => ({
  type: constants.ACTIVATE_DAY,
  payload: id,
});

export const activateStream = (stream) => ({
  type: constants.ACTIVATE_STREAM,
  payload: stream,
});

export const createStream = (stream) => ({
  type: constants.CREATE_STREAM,
  payload: stream,
});

export const updateStream = (stream) => ({
  type: constants.UPDATE_STREAM,
  payload: stream,
});

export const fetchStreamsSuccess = (streams) => ({
  type: constants.FETCH_STREAMS_SUCCESS,
  payload: { streams },
});

export const selectStream = (streamId) => ({
  type: constants.SELECT_STREAM,
  payload: { streamId },
});

export const setProgram = (program) => ({
  type: constants.SET_PROGRAM,
  payload: program,
});

export const showCreateProgramModal = () => ({
  type: constants.SHOW_CREATE_PROGRAM_MODAL,
});

export const hideCreateProgramModal = () => ({
  type: constants.HIDE_CREATE_PROGRAM_MODAL,
});

export const hideEditSeriesModal = () => ({
  type: constants.HIDE_EDIT_SERIES_MODAL,
});
export const hideCreateSeriesModal = () => ({
  type: constants.HIDE_CREATE_SERIES_MODAL,
});
export const showEditProgramModal = (program) => ({
  type: constants.SHOW_EDIT_PROGRAM_MODAL,
  payload: { ...program },
});
export const hideEditProgramModal = () => ({
  type: constants.HIDE_EDIT_PROGRAM_MODAL,
});

export const showCreateStreamModal = () => ({
  type: constants.SHOW_CREATE_STREAM_MODAL,
});

export const hideCreateStreamModal = () => ({
  type: constants.HIDE_CREATE_STREAM_MODAL,
});

export const showEditStreamModal = () => ({
  type: constants.SHOW_EDIT_STREAM_MODAL,
});

export const hideEditStreamModal = () => ({
  type: constants.HIDE_EDIT_STREAM_MODAL,
});

export const hideEditDayModal = () => ({
  type: constants.HIDE_EDIT_DAY_MODAL,
});

export const showEditSeriesModal = () => ({
  type: constants.SHOW_EDIT_SERIES_MODAL,
});

export const showCreateSeriesModal = () => ({
  type: constants.SHOW_CREATE_SERIES_MODAL,
});

export const showEditDayModal = () => ({
  type: constants.SHOW_EDIT_DAY_MODAL,
});

export const createProgram = (program) => ({
  type: constants.CREATE_PROGRAM,
  payload: program,
});

export const createProgramSuccess = (program) => ({
  type: constants.CREATE_PROGRAM_SUCCESS,
  payload: program,
});

export const createSeries = (series) => ({
  type: constants.CREATE_SERIES,
  payload: series,
});

export const createDay = (day) => ({
  type: constants.CREATE_DAY,
  payload: day,
});

export const addCard = () => {
  let cards = getCards(store.getState().Programming);
  let len = cards.length;
  let uuid = uuid4();
  cards.push({ id: uuid, title: uuid, data: [] });
  console.log("returning out of addcard");
  return {
    type: constants.ADD_CARD,
    payload: cards,
  };
};

export const addExercise = (exercise, card_id) => {
  let ex_list = getExercises(store.getState().Programming);
  let len = ex_list.length;
  // ex_list.push({ id: exercise.id, card_id: cardId, text: exercise.name });
  if (exercise.type === "new") {
    ex_list.push({
      id: uuid4(),
      card_id: card_id,
      text: exercise.name,
      index: ex_list.length,
    });
  } else {
    ex_list[exercise.index].card_id = card_id;
  }

  return {
    type: constants.PROGRAMMING_ADD_EXERCISE,
    payload: ex_list,
  };
};

export const fetchPrograms = (user_id) => ({
  type: constants.FETCH_PROGRAMS,
  payload: user_id,
});

export const fetchProgramsSuccess = (programs) => {
  let response = programs.sort((a, b) =>
    a.created_on > b.created_on ? -1 : 1
  );

  return {
    type: constants.FETCH_PROGRAMS_SUCCESS,
    payload: response,
  };
};

export const fetchFullProgramSuccess = (full_program) => ({
  type: constants.FETCH_FULL_PROGRAM_SUCCESS,
  payload: { full_program },
});

export const addNewDay = () => {
  let selected_program = { ...store.getState().Programming.selected_program };
  selected_program.days.push({
    day_number: selected_program.days.length + 1,
    entities: [],
  });
  return {
    type: constants.ADD_NEW_DAY,
    payload: { selected_program },
  };
};
export const updateSeries = (series) => ({
  type: constants.UPDATE_SERIES,
  payload: series,
});

export const activateSeries = (seriesId) => ({
  type: constants.ACTIVATE_SERIES,
  payload: seriesId,
});

export const updateDay = (day) => ({
  type: constants.UPDATE_DAY,
  payload: day,
});

export const updateSelectedProgram = (program) => ({
  type: constants.UPDATE_SELECTED_PROGRAM,
  payload: program,
});

export const updateProgram = (program) => ({
  type: constants.UPDATE_PROGRAM,
  payload: program,
});

export const deleteProgram = (program) => ({
  type: constants.DELETE_PROGRAM,
  payload: program,
});

export const deleteExerciseFromSeries = (exerciseId) => {
  const {
    selected_program,
    selectedDayId,
    selectedSeriesId,
  } = store.getState().Programming;
  console.log(exerciseId);

  //don't modify the state directly

  var edited_program = _.cloneDeep(selected_program);
  var day = edited_program.days.find((d) => d.id === selectedDayId);
  var series = day.entities.find((e) => e.id === selectedSeriesId);

  //this references inside the edited_program object
  series.exercises = series.exercises.filter((ex) => ex.id !== exerciseId);

  console.log("edited program", edited_program);

  //intentially sidestep the backend saga so it isn't saved until we hit update on the modal
  return {
    type: constants.PATCH_PROGRAM_SUCCESS,
    payload: edited_program,
  };
};

export const deleteSeriesFromProgram = (series) => {
  // const {
  //   selected_program,
  //   selectedDayId,
  //   selectedSeriesId
  // } = store.getState().Programming;

  //don't modify the state directly
  // var edited_program = _.cloneDeep(selected_program);
  // var day = edited_program.days.find(d => d.id === selectedDayId);
  // var entities = day.entities.filter(e => e.id !== seriesId);

  // day.entities = entities;
  console.log("deleteSeriesFromProgram", series);

  return {
    type: constants.DELETE_SERIES,
    payload: series,
  };
};

export const deleteDayFromProgram = (day) => {
  return {
    type: constants.DELETE_DAY_FROM_PROGRAM,
    payload: day,
  };
};

export const addExerciseToSeries = (exerciseObj) => {
  const {
    selected_program,
    selectedDayId,
    selectedSeriesId,
  } = store.getState().Programming;
  // console.log(exerciseId);

  //don't modify the state directly

  var edited_program = _.cloneDeep(selected_program);
  var day = edited_program.days.find((d) => d.id === selectedDayId);
  var series = day.entities.find((e) => e.id === selectedSeriesId);

  //need to wrap the actual exercise object in an exerciseworkout object
  var new_ex_job = {
    id: uuid4(),
    program_series_id: series.id,
    exercise_id: exerciseObj.id,
    exercise: exerciseObj,
  };

  //this references inside the edited_program object
  series.exercises.push(new_ex_job);

  console.log("edited program", edited_program);

  //intentially sidestep the backend saga so we can undo
  return {
    type: constants.PATCH_PROGRAM_SUCCESS,
    payload: edited_program,
  };
};

export const deactivatePrograms = () => ({
  type: constants.DEACTIVATE_PROGRAMS,
});

export const showCreateExerciseModal = () => ({
  type: constants.SHOW_CREATE_EXERCISE_MODAL,
});
export const hideCreateExerciseModal = () => ({
  type: constants.HIDE_CREATE_EXERCISE_MODAL,
});
export const showEditExerciseModal = () => ({
  type: constants.SHOW_EDIT_EXERCISE_MODAL,
});
export const hideEditExerciseModal = () => ({
  type: constants.HIDE_EDIT_EXERCISE_MODAL,
});
export const selectExercise = (exercise) => ({
  type: constants.SELECT_EXERCISE,
  payload: exercise,
});
export const showCreateDayModal = () => ({
  type: constants.SHOW_CREATE_DAY_MODAL,
});
export const hideCreateDayModal = () => ({
  type: constants.HIDE_CREATE_DAY_MODAL,
});

export const clipboardDayFromLog = (day) => ({
  type: constants.CLIPBOARD_DAY,
  payload: day,
});

export const clipboardDayFromProgram = (day) => {
  // let program = store.getState().Programming.selected_program;
  // let day = program.days.find(d => d.id === dayId);
  return { type: constants.CLIPBOARD_DAY, payload: day };
};

export const pasteDay = (day) => ({
  type: constants.PASTE_DAY,
  payload: day,
});

export const clipboardSeriesFromLog = (series) => ({
  type: constants.CLIPBOARD_SERIES,
  payload: series,
});

export const clipboardSeriesFromProgram = (dayId, seriesId) => {
  let program = store.getState().Programming.selected_program;
  let day = program.days.find((d) => d.id === dayId);
  let series = day.entities.find((e) => e.id === seriesId);
  return { type: constants.CLIPBOARD_SERIES, payload: series };
};

export const setClipboardSeries = (series) => {
  return { type: constants.CLIPBOARD_SERIES, payload: series };
};

export const pasteSeries = (dayId, series) => ({
  type: constants.PASTE_SERIES,
  payload: { dayId, series },
});

export const showEditAddedExerciseModal = (handle_change, exercises) => ({
  type: constants.SHOW_EDIT_ADDED_EXERCISE_MODAL,
  handle_change: handle_change,
  exercises: exercises,
});

export const hideEditAddedExerciseModal = () => ({
  type: constants.HIDE_EDIT_ADDED_EXERCISE_MODAL,
});

export const activateExercise = (payload) => ({
  type: constants.ACTIVATE_EXERCISE,
  payload,
});

export const updateAddedExercise = (payload) => ({
  type: constants.UPDATE_ADDED_EXERCISE,
  payload,
});

export const clipboardProgram = (program_id) => {
  let program = store.getState().Programming.selected_program;

  return {
    type: constants.CLIPBOARD_PROGRAM,
    payload: program,
  };
};
export const deactivateStream = () => ({
  type: constants.DEACTIVATE_STREAM,
});
export const filterProgramForAll = (choice) => ({
  type: constants.FILTER_PROGRAM_FOR_ALL,
  payload: choice,
});
export const filterProgramSpecificAthletes = (choice) => ({
  type: constants.FILTER_PROGRAM_SPECIFIC_ATHLETES,
  payload: choice,
});

export const showCreateProgressionExercise = () => ({
  type: constants.SHOW_CREATE_PROGRESSION_EXERCISE,
});

export const hideCreateProgressionExercise = () => ({
  type: constants.HIDE_CREATE_PROGRESSION_EXERCISE,
});
export const patchProgressionDay = (payload) => ({
  type: constants.PATCH_PROGRESSION_DAY,
  payload,
});
export const patchDays = (payload) => ({
  type: constants.PATCH_DAYS,
  payload,
});

export const showPublishingModal = () => ({
  type: constants.SHOW_PUBLISHING_MODAL,
});

export const hidePublishingModal = () => ({
  type: constants.HIDE_PUBLISHING_MODAL,
});

export const setSelectedProgram = (payload) => ({
  type: constants.SET_SELECTED_PROGRAM,
  payload,
});

export const showTeamModal = (payload) => ({
  type: constants.SHOW_TEAM_MODAL,
  payload,
});

export const patchPrograms = (program) => ({
  type: constants.PATCH_PROGRAM_SUCCESS,
  payload: program,
});

export const patchStreams = (payload) => ({
  type: constants.PATCH_STREAMS,
  payload,
});
